/**
 * @fileoverview Table Controls Column Picker
 * @author Derek Seo (dseo@yext.com)
 */
// @ts-nocheck
import {SelectController} from '/ui/components/select/selectcontroller';
import {Option} from '/ui/components/select/types/option';
import * as Types from '/ui/components/table/types';
import * as Toast from '/ui/components/toast/toast';
import {yext} from '/ui/lib/msg';

/**
 * @param {!Array<!Option>} selectedOptions
 * @return {string}
 */
function multiselectLabeller(selectedOptions) {
  return yext.msg('Columns ({0})', selectedOptions.length);
}
/**
 *
 * @param {{
 *   columns: !Array<!Types.Column>,
 *   isLoading: (boolean|undefined),
 *   columnPickerConfig: !Types.ColumnPickerConfig,
 * }} props
 * @returns {React.ReactElement}
 */
export function ColumnPicker({
  columns,
  isLoading,
  columnPickerConfig: {
    onColumnPickerSelect,
    onColumnPickerReset,
    excludedColumns,
  },
}) {
  const [options, selectedOptions] = React.useMemo(() => {
    const options = [];
    const selectedOptions = [];
    columns.forEach(col => {
      if (excludedColumns && excludedColumns.has(col.id)) {
        return;
      }
      options.push({
        value: col.id,
        label: col.label,
        disabled: isLoading,
      });
      if (!col.hidden) {
        selectedOptions.push(col.id);
      }
    });
    return [options, selectedOptions];
  }, [columns, isLoading, excludedColumns]);

  const actionLink = isLoading ? undefined : {
    label: yext.msg('Reset Columns'),
    onClick: onColumnPickerReset,
  };
  const onSelect = selectedValues => {
    if (selectedValues.length === 0) {
      Toast.showErrorToast(yext.msg('You must have at least 1 column selected.'));
    } else {
      onColumnPickerSelect(selectedValues);
    }
  };
  return (
    <SelectController
      config={{
        disabled: isLoading,
        multiselect: true,
        allowContainerOverflow: true,
        actionLink,
        onSelect,
        enableSearch: true,
        multiselectLabeller,
      }}
      options={options}
      selectedOptions={selectedOptions}
    />
  );
}
